
import RequestService from '../request-service';

export default class WinningsDetailsRequestService extends RequestService {
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.winningsDetails;
    this.method = 'get';
    const { Culture } = this.$config.defaultHeaders;
    this.getParams = {
      Culture: Culture,
      externalUserID: APP_SETTINGS.player.id,
      betSlipGroupID: null,
      isAssisted: false,
      brandID: null,
      timeOffset: null,
      tokenType: null,
      // token: ''
    };
  }
}
